import request from '../utils/request';
import http from "@utils/request";

export function getRolesApi(params) {
  return request({
    url: '/api/role_list/',
    method: 'get',
    params
  })
}

export function getPermissionList(id, params) {
  return request({
    url: `/api/permission_module/${id}/`,
    method: 'get',
    params: {page_size: params}
  })
}

export function getExcelPermission(params) {
  return http.get(`/api/get_roles_excel/?role_id=${params.id}`, {
    responseType: params.excel ? "blob" : undefined,
    timeout: 0,
  });
}

export function getExcel(params) {
  return http.get("/api/get_roles_excel/", {
    responseType: params.excel ? "blob" : undefined,
    timeout: 0,
  });
}

export function getPermissionListChildren(role_id, id, params) {
  return request({
    url: `/api/permission_module/${role_id}/?parent_id=${id}`,
    method: 'get',
    params: {page_size: params}
  })
}


export function getUsersData(params) {
  return request({
    url: '/api/settings/users/',
    // url: '/api/settings/get-users-data/',
    method: 'get',
    params

  })
}

export function addUserData(data) {
  return request({
    url: '/api/settings/get-users-data/',
    method: 'post',
    data,
  })
}

export function EditPermission(data) {
  return request({
    url: '/api/update_permission_module_v2/',
    method: 'patch',
    data,
  })
}

export function editUserData(data) {
  return request({
    url: '/api/settings/get-users-data/',
    method: 'put',
    data,
  })
}

export function deleteUserData(data) {
  return request({
    url: `/api/settings/users/${data.id}/`,
    method: 'delete',
  })
}

export function updateRole(data) {
  return request({
    url: `/api/auth/active_or_deactive_role_notification/${data.id}/`,
    method: 'patch',
    data,
  })
}

export function deleteRole(data) {
  return request({
    url: `/api/auth/role_delete/${data.id}/`,
    method: 'delete',
  })
}

export function addRole(data) {
  return request({
    url: '/api/auth/role_create/',
    method: 'post',
    data,
  })
}

export function updateRole2(data) {
  return request({
    url: `/api/auth/role_update/${data.id}/`,
    method: 'patch',
    data,
  })
}
